// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CLha","content":"styles_content__1HyyT"};